export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5934.1ad9899a.jpg";